import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const royaltyPlanTemplateStart = (accessToken, data) => baseAction.actionStart(actionTypes.ROYALTYPLANTEMPLATE_START, accessToken, data);
export const royaltyPlanTemplateSuccess = (data) => baseAction.actionSuccess(actionTypes.ROYALTYPLANTEMPLATE_SUCCESS, data);
export const royaltyPlanTemplateFail = (error) => baseAction.actionFail(actionTypes.ROYALTYPLANTEMPLATE_FAIL, error);

export const royaltyPlanTemplateSelect = (options) => {
    return (dispatch, getState) => {
        if (options && options.royaltyPlanTemplateId) {
            baseAction.actionExecute(dispatch, getState, {
                url: `/RoyaltyPlanTemplate/${options.royaltyPlanTemplateId}`,
                startFn: (accessToken) => dispatch(royaltyPlanTemplateStart(accessToken, { lastScope: 'select' })),
                successFn: (response) => dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplate: response.data, isNew: false })),
                failFn: (error) => dispatch(royaltyPlanTemplateFail(error))
            });
        } else {
            dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplate: null, isNew: true }));
        }
    };
};

export const royaltyPlanTemplateList = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            url: `/RoyaltyPlanTemplate`,
            startFn: (accessToken) => dispatch(royaltyPlanTemplateStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplates: response.data })),
            failFn: (error) => dispatch(royaltyPlanTemplateFail(error))
        });
    };
};

export const royaltyPlanTemplateCreate = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            url: `/RoyaltyPlanTemplate`,
            payload: options.data,
            startFn: (accessToken) => dispatch(royaltyPlanTemplateStart(accessToken, { lastScope: 'create' })),
            successFn: (response) => dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplate: response.data, isNew: false })),
            failFn: (error) => dispatch(royaltyPlanTemplateFail(error))
        });
    };
};

export const royaltyPlanTemplateDuplicate = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'post',
            url: `/RoyaltyPlanTemplate/${options.royaltyPlanTemplateId}/Duplicate`,
            payload: options.data,
            startFn: (accessToken) => dispatch(royaltyPlanTemplateStart(accessToken, { lastScope: 'duplicate' })),
            successFn: (response) => dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplate: response.data, isNew: false })),
            failFn: (error) => dispatch(royaltyPlanTemplateFail(error))
        });
    }
};

export const royaltyPlanTemplateUpdate = (options) => {  
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'update',
            url: `/RoyaltyPlanTemplate/${options.royaltyPlanTemplateId}`,
            payload: options.data,
            startFn: (accessToken) => dispatch(royaltyPlanTemplateStart(accessToken, { lastScope: 'update' })),
            successFn: (response) => dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplate: response.data, isNew: false })),
            failFn: (error) => dispatch(royaltyPlanTemplateFail(error))
        });
    };
};

export const royaltyPlanTemplateDelete = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'delete',
            url: `/RoyaltyPlanTemplate/${options.royaltyPlanTemplateId}`,
            startFn: (accessToken) => dispatch(royaltyPlanTemplateStart(accessToken, { lastScope: 'delete' })),
            successFn: () => dispatch(royaltyPlanTemplateSuccess({ royaltyPlanTemplate: null, isNew: false })),
            failFn: (error) => dispatch(royaltyPlanTemplateFail(error))      
        });
    };
};
